import React from "react";
import Productpage from "../../productpage2";
import SEO from "../../seo";
export default function OrthoViscoLXPage({ location }) {
  const data = {
    galleryImages: [
      "https://eclipsemattress.in/assets/images/products/ortho-visco-lx/Ortho-Visco-LX-n-04.png",
      "https://eclipsemattress.in/assets/images/products/ortho-visco-lx/Ortho-Visco-LX-n-01.png",
      "https://eclipsemattress.in/assets/images/products/ortho-visco-lx/Ortho-Visco-LX-n-02.png",
      "https://eclipsemattress.in/assets/images/products/ortho-visco-lx/Ortho-Visco-LX-n-03.png",
    ],
    productName: "Ortho Visco LX",
    productLogo:
      "https://eclipsemattress.in/assets/images/products/ortho-visco-lx/Ortho-Visco-LX.png",
    category: { title: "Luxury Collection", link: "/luxury-collection/" },
    descriptionTitle: "",
    descriptionText:
      "Ortho Visco LX is a scientifically designed mattress with a customised Memory Foam layer for enhanced airflow. Enhanced airflow eliminates the problem of heating in tropical conditions of India subcontinent. Memory foam also helps in reduction of stress by relieving the pressure points.",

    points: [
      "Eclipse Orthobond core with customized profile Memory Foam layer",
      "Scientifically designed for enhanced airflow & comfort",
      "Eliminates heating issues in tropical conditions",
      "Odour-free, eco-friendly and breathable",
      "Pressure-relieving",
    ],

    featuresText: [
      "Eclipse Memory Foam",
      "Eclipse HD Foam",
      "Eclipse Orthobond Foam",
    ],
    featuresImage:
      "https://eclipsemattress.in/assets/images/products/ortho-visco-lx/Ortho-Visco-LX-n-06.png",
    warrantyIcons: [
      "https://eclipsemattress.in/assets/images/products/ortho-visco-lx/Ortho-Visco-LX-n-07.png",
      "https://eclipsemattress.in/assets/images/products/ortho-visco-lx/Ortho-Visco-LX-n-08.png",
      "https://eclipsemattress.in/assets/images/products/ortho-visco-lx/Ortho-Visco-LX-n-09.png",
      "https://eclipsemattress.in/assets/images/products/ortho-visco-lx/Ortho-Visco-LX-n-10.png",
      "https://eclipsemattress.in/assets/images/products/ortho-visco-lx/Ortho-Visco-LX-n-11.png",
      // "https://eclipsemattress.in/assets/images/products/ortho-visco-lx/Ortho-Visco-LX-n-07.png",
    ],

    warrantyImage:
      "https://eclipsemattress.in/assets/images/products/ortho-visco-lx/Ortho-Visco-LX-n-05.png",
    price: "₹21,199 - ₹74,579",
    brochureLink:
      "https://eclipsemattress.in/assets/pdfs/Patent-&-Luxury-Catalogue.pdf",
    relatedProducts: [
      {
        title: "Harmony Ortho",
        img: "https://eclipsemattress.in/assets/images/product_thumbnails/harmonyortho.jpg",
        link: "/harmony-collection/harmony-ortho/",
      },
      {
        title: "Ortho Latex LX",
        img: "https://eclipsemattress.in/assets/images/product_thumbnails/ortho-latex-lx.jpg",
        link: "/luxury-collection/ortho-latex-lx/",
      },
      {
        title: "Ortho Care LX",
        img: "https://eclipsemattress.in/assets/images/product_thumbnails/ortho-care-lx.jpg",
        link: "/serene-series/ortho-care-lx/",
      },
    ],
  };

  return (
    <div>
      <SEO
        title="Ortho Memory Foam Mattress | Eclipse International"
        description="Buy Ortho Visco LX which is a memory foam mattress that eliminates the problem of heating in tropical conditions. Free of odors, environmental friendly and breathable."
        img="https://eclipsemattress.in/assets/linkpreviews/link-preview-orthoviscolx.jpg"
      />
      <Productpage location={location} product={data} />
    </div>
  );
}
